import { ApproveTask } from "../../classes";
import store from "../../store";
const ApproveTaskModule = {
  namespaced: true,
  state: {
    approveTaskSettingHistory: [],
    approveTasks: [],
    approveTask: null
  },
  actions: {
    async getApproveTasksSettingHistoryByMarket({ commit, rootGetters }, payload) {
      try {
        let marketId = rootGetters["markets/getMarketId"] ? rootGetters["markets/getMarketId"] : payload.marketId
        commit("setApproveTaskSettingHistory", []);
        const data = await ApproveTask.getApproveTaskSettingByMarket({
          ...payload,
          marketId
        });
        commit("setApproveTaskSettingHistory", data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async getApproveTasksByMarket({ commit, rootGetters }, payload) {
      try {
        let marketId = rootGetters["markets/getMarketId"] ? rootGetters["markets/getMarketId"] : payload.marketId
        commit("setApproveTasks", []);
        const data = await ApproveTask.getApproveTasksByMarket({
          ...payload,
          marketId
        });
        commit("setApproveTasks", data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async approveApproveTask({ commit, dispatch }, payload) {
      try {
        const data = await ApproveTask.approveApproveTask(payload);
        store.dispatch("user/getUserInfo");
        return data;
      } catch (error) {
        throw error;
      }
    },
    async rejectApproveTask({ commit, dispatch }, payload) {
      try {
        const data = await ApproveTask.rejectApproveTask(payload);
        store.dispatch("user/getUserInfo");
        return data;
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    approveTaskSettingHistory: state => state.approveTaskSettingHistory,
    approveTasks: state => state.approveTasks,
    approveTask: state => state.approveTaskm,
    countApproveTaskAreaInterest: state => state.approveTasks.filter(item => item.type === 'area_interest').length || 0,
    countApproveTaskAppeal: state => state.approveTasks.filter(item => item.type === 'appeal').length || 0,
    countApproveTaskSettingBilling: state => state.approveTasks.filter(item => item.sub_type && item.sub_type[0] === 'billing_setting').length || 0,
    countApproveTaskSettingAreaAcc: state => state.approveTasks.filter(item => item.sub_type && item.sub_type[0] === 'area_accounting_product').length || 0,
    countApproveTaskContractCheckOut: state => state.approveTasks.filter(item => item.type === 'contract_check_out').length || 0,
    getByType: state => type => state.approveTasks.filter(item => item.type === type) || [],
    getBySubType: state => subType => state.approveTasks.filter(item => item.sub_type && item.sub_type[0] === subType) || [],
  },
  mutations: {
    setApproveTaskSettingHistory(state, approveTaskSettingHistory) {
      state.approveTaskSettingHistory = approveTaskSettingHistory;
    },
    setApproveTasks(state, approveTasks) {
      state.approveTasks = approveTasks;
    },
    setApproveTask(state, approveTask) {
      state.approveTask = approveTask;
    }
  }
};
export default ApproveTaskModule;
